// extracted by mini-css-extract-plugin
export default {"zoomControls":"Faa-z","zoomControlButton":"Gaa-z","zoomBanner":"Haa-z","bannerButton":"Iaa-z","imageButton":"Jaa-z","zoom":"Kaa-z","zoomContent":"Laa-z"};